"use client";
import type { Document } from "@contentful/rich-text-types";
import { AnalyticsListTypes } from "@lib/analytics/analyticsTypes";
import { useGetRecentlyViewedProducts } from "@components/commerce/product/recently-viewed/useRecentlyViewedProducts";
import { SearchProductsHitsToCarousel } from "@components/commerce/product/product-carousel/SearchProductHitsToCarousel";
import { memo, useMemo } from "react";

export interface RecentProductsProps {
    headline: string;
    authorizationInvitation?: Document;
}

export const RecentProducts = memo(({ headline, authorizationInvitation }: RecentProductsProps) => {
    const savedProducts = useGetRecentlyViewedProducts();
    const recentProductKeys = useMemo(() => {
        return savedProducts.map((p) => {
            return p.key;
        });
    }, [savedProducts]);

    return (
        <SearchProductsHitsToCarousel
            products={recentProductKeys}
            headline={headline}
            assistiveMessage="Recent Products"
            sortingOrder={recentProductKeys}
            carouselType={AnalyticsListTypes.recentlyViewed}
            authorizationInvitation={authorizationInvitation}
        />
    );
});

RecentProducts.displayName = "RecentProducts";

export default RecentProducts;
